import React, { useContext, useMemo } from 'react';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import OrderMainDashboard from './OrderMainDashboard';
import OnboardingComp from './OnboardingComp';
import OnboardingPendingReview from './OnboardingPendingReview';
import OnboardingDedicatedManager from './OnboardingDedicatedManager';
import OrderDashboardSkeleton from './OrderDashboardSkeleton';

function isOnboardingFlagTrue(value) {
  return value === true || value === 'true';
}

const OrderDashboard = () => {
  const { onLoadInfoResponse } = useContext(GlobalStateDataContext);
  const { loading, data } = onLoadInfoResponse;
  const kitchenData = data?.data?.data;

  const onboardingStatus = useMemo(() => {
    return kitchenData?.kitchenOperationObject?.onborading_status ?? {};
  }, [kitchenData]);

  if (loading || !kitchenData) {
    return <OrderDashboardSkeleton />;
  }

  const einMenuUploaded = isOnboardingFlagTrue(onboardingStatus.ein_menu_uploaded);
  const dedicatedManagerAssigned = isOnboardingFlagTrue(
    onboardingStatus.dedicated_manager_assigned
  );
  const deviceAssigned = isOnboardingFlagTrue(onboardingStatus.device_assigned);

  if (!einMenuUploaded) {
    return <OnboardingComp />;
  }

  if (!dedicatedManagerAssigned) {
    return <OnboardingPendingReview />;
  }

  if (deviceAssigned) {
    return <OrderMainDashboard />;
  }

  return <OnboardingDedicatedManager />;
};

export default OrderDashboard;
